import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container px-7" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    style: {"width":"100%"},
    size: "10",
    color: "black"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0",
  style: {"min-height":"20px !important"}
}, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "card-title align-items-start flex-column",
    style: {"font-weight":"900","font-size":"large"}
  }, " Form Upload Desain ")
], -1)
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-6 fv-row" }
const _hoisted_7 = { class: "row px-3" }
const _hoisted_8 = { class: "col-lg-12 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Upload Desain Depan", -1)
const _hoisted_10 = { class: "col-lg-12 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Depan", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "col-lg-6 fv-row" }
const _hoisted_14 = { class: "row px-3" }
const _hoisted_15 = { class: "col-lg-12 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Upload Desain Belakang", -1)
const _hoisted_17 = { class: "col-lg-12 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, "Preview Kartu Belakang", -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "card-footer border-0 d-flex justify-content-end py-6 px-9" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "container px-7" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    style: {"width":"100%"},
    size: "10",
    color: "black"
  })
], -1)
const _hoisted_22 = {
  class: "card-header border-0",
  style: {"min-height":"20px !important"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", {
  class: "card-title align-items-start flex-column mb-5",
  style: {"font-weight":"900","font-size":"large"}
}, " List Kartu ", -1)
const _hoisted_24 = { class: "container px-0" }
const _hoisted_25 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-md-2 mb-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-md-2 mb-1" }, null, -1)
const _hoisted_28 = { class: "col-sm-6 col-md-12 mb-1 d-flex justify-content-end" }
const _hoisted_29 = {
  key: 1,
  style: {"margin-right":"190px"},
  id: "myDropdownHistory",
  class: "dropdown-content"
}
const _hoisted_30 = {
  key: 2,
  id: "myDropdown",
  class: "dropdown-content",
  style: {"margin-right":"100px"}
}
const _hoisted_31 = {
  key: 3,
  style: {},
  id: "myDropdownDownload",
  class: "dropdown-content"
}
const _hoisted_32 = { class: "container px-0" }
const _hoisted_33 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_34 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_35 = { class: "d-flex align-items-center position-relative" }
const _hoisted_36 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_37 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_38 = { class: "d-flex align-items-center position-relative" }
const _hoisted_39 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_40 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_41 = { class: "d-flex align-items-center position-relative" }
const _hoisted_42 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_43 = { class: "d-flex align-items-center position-relative" }
const _hoisted_44 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_45 = { class: "d-flex align-items-center position-relative" }
const _hoisted_46 = { class: "col-sm-6 col-md-2 mb-1" }
const _hoisted_47 = { class: "d-flex align-items-center position-relative" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-md-2 mb-1" }, null, -1)
const _hoisted_49 = { class: "card-body py-3" }
const _hoisted_50 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_51 = {
  class: "row mb-5",
  style: {"margin-right":"5px","padding-top":"10px","background-color":"aliceblue","border-radius":"15px 15px 15px 15px"}
}
const _hoisted_52 = {
  class: "col-lg-12 fv-row",
  style: {"text-align":"center"}
}
const _hoisted_53 = {
  class: "card-title align-items-center flex-column",
  style: {"font-weight":"700","font-size":"15px"}
}
const _hoisted_54 = { class: "col-lg-3 fv-row" }
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "col-lg-9 fv-row" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_61 = { class: "col-7" }
const _hoisted_62 = { style: {"font-size":"12px"} }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_66 = { class: "col-7" }
const _hoisted_67 = { style: {"font-size":"12px"} }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " TTL ")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_71 = { class: "col-7" }
const _hoisted_72 = { style: {"font-size":"12px"} }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Kelas ")
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_76 = { class: "col-7" }
const _hoisted_77 = { style: {"font-size":"12px"} }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_81 = { class: "col-7" }
const _hoisted_82 = { style: {"font-size":"12px"} }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Jenis Kelamin ")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_86 = { class: "col-7" }
const _hoisted_87 = { style: {"font-size":"12px"} }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Alamat ")
], -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_93 = { class: "col-7" }
const _hoisted_94 = { style: {"font-size":"12px"} }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Tags ")
], -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_98 = { class: "col-7" }
const _hoisted_99 = { style: {"font-size":"12px"} }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Note ")
], -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_103 = { class: "col-7" }
const _hoisted_104 = { style: {"font-size":"12px"} }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Status Kartu ")
], -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_108 = { class: "col-7" }
const _hoisted_109 = { class: "row" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Verifikasi Sekolah ")
], -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_112 = { class: "col-7" }
const _hoisted_113 = { class: "col-lg-12 fv-row" }
const _hoisted_114 = {
  class: "card-footer border-0 d-flex justify-content-end py-6 px-9",
  style: {"padding-right":"5px !important"}
}
const _hoisted_115 = ["onClick"]
const _hoisted_116 = ["onClick"]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = ["onClick"]
const _hoisted_119 = {
  key: 1,
  class: "row mb-7 mt-5"
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"font-size":"20px","text-align":"center","font-weight":"600"}
}, " Tidak Ada Data ", -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = { class: "row mt-5 mb-5" }
const _hoisted_123 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_124 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_125 = ["label", "value"]
const _hoisted_126 = { class: "p-3" }
const _hoisted_127 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_128 = { class: "pagination" }
const _hoisted_129 = { class: "row mt-5 mb-5" }
const _hoisted_130 = {
  class: "modal fade",
  ref: "uploadModalMultipleRef",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_foto_multiple"
}
const _hoisted_131 = { class: "modal-dialog" }
const _hoisted_132 = { class: "modal-content" }
const _hoisted_133 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_134 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Upload Multiple Foto ", -1)
const _hoisted_135 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_136 = { class: "svg-icon svg-icon-2x" }
const _hoisted_137 = { class: "modal-body row pt-1" }
const _hoisted_138 = {
  key: 0,
  class: "row mt-0"
}
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Pilih File Foto")
], -1)
const _hoisted_140 = {
  key: 1,
  class: "row mt-0"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", {
  style: {"text-align":"left"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px"} }, "Hasil Upload File ")
], -1)
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = {
  key: 2,
  class: "row mt-0"
}
const _hoisted_144 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Total Upload</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_146 = { class: "col-3" }
const _hoisted_147 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_148 = { style: {"font-size":"18px","color":"blue"} }
const _hoisted_149 = {
  key: 3,
  class: "row mt-0"
}
const _hoisted_150 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Berhasil</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_152 = { class: "col-3" }
const _hoisted_153 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_154 = { style: {"font-size":"18px","color":"green"} }
const _hoisted_155 = {
  key: 4,
  class: "row mt-0"
}
const _hoisted_156 = /*#__PURE__*/_createStaticVNode("<div class=\"col-8\"><label style=\"text-align:left;margin-left:10px;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">Gagal</span></label></div><div class=\"col-1\"><label style=\"text-align:left;padding:3px;\" class=\"col-lg-12 col-form-label fw-bold fs-6\"><span style=\"font-size:18px;\">:</span></label></div>", 2)
const _hoisted_158 = { class: "col-3" }
const _hoisted_159 = {
  style: {"text-align":"left","padding":"3px"},
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_160 = { style: {"font-size":"18px","color":"red"} }
const _hoisted_161 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"container px-2 mt-3 mb-3\"><hr style=\"width:100%;\" size=\"5\" color=\"black\"></div></div><div class=\"row mb-3 mx-2\" style=\"font-size:18px;\"> Keterangan </div><div class=\"row\"><div class=\"col-12 mx-2\"><label style=\"font-size:13px;\"> - Upload foto bisa lebih dari satu file </label><label style=\"font-size:13px;\"> - Nama Foto harus berupa NIS siswa yang ada di PSP </label><label style=\"font-size:13px;margin-left:15px;\"> Contoh : <span style=\"color:blue;\">202204</span>.jpg </label><br><label style=\"font-size:13px;\"> - Format file foto berupa .jpg, .jpeg, .png, </label></div></div>", 3)
const _hoisted_164 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_165 = {
  key: 1,
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_166 = {
  key: 2,
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}
const _hoisted_167 = { class: "row mt-5 mb-5" }
const _hoisted_168 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_verifikasi_multiple"
}
const _hoisted_169 = { class: "modal-dialog" }
const _hoisted_170 = { class: "modal-content" }
const _hoisted_171 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_172 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " Verifikasi Semua Data ", -1)
const _hoisted_173 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_174 = { class: "svg-icon svg-icon-2x" }
const _hoisted_175 = { class: "modal-body row pt-1" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"font-size":"18px","text-align":"center","margin-top":"15px","font-weight":"800"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "Informasi Kelengkapan foto")
], -1)
const _hoisted_177 = {
  class: "row",
  style: {"text-align":"center","margin-top":"15px"}
}
const _hoisted_178 = { class: "col-12" }
const _hoisted_179 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_180 = /*#__PURE__*/_createTextVNode(" Data dengan foto : ")
const _hoisted_181 = { style: {"color":"blue"} }
const _hoisted_182 = { class: "col-12" }
const _hoisted_183 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_184 = /*#__PURE__*/_createTextVNode(" Data tanpa foto : ")
const _hoisted_185 = { style: {"color":"red"} }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"font-size":"16px","text-align":"center","margin-top":"15px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 px-7" }, " Apakah anda yakin akan melakukan semua verifikasi data kartu ? ")
], -1)
const _hoisted_187 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_188 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_189 = { class: "row mt-5 mb-5" }
const _hoisted_190 = {
  class: "modal",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_excel"
}
const _hoisted_191 = { class: "modal-dialog" }
const _hoisted_192 = { class: "modal-content" }
const _hoisted_193 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_194 = {
  key: 0,
  class: "modal-title justify-content-center"
}
const _hoisted_195 = {
  key: 1,
  class: "modal-title"
}
const _hoisted_196 = {
  key: 2,
  class: "modal-title"
}
const _hoisted_197 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_198 = { class: "svg-icon svg-icon-2x" }
const _hoisted_199 = { class: "modal-body row pt-1" }
const _hoisted_200 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_201 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Data Excel"),
  /*#__PURE__*/_createElementVNode("span", null, "         "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format dokumen .xlsx )")
], -1)
const _hoisted_202 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_203 = { class: "fv-help-block" }
const _hoisted_204 = {
  key: 2,
  class: "row"
}
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/checklist_icon.svg",
    alt: ""
  })
], -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Sukses Melakukan Upload Dokumen ", -1)
const _hoisted_207 = [
  _hoisted_205,
  _hoisted_206
]
const _hoisted_208 = {
  key: 3,
  class: "row"
}
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"125px","margin-bottom":"15px","margin-top":"15px"},
    src: "/media/icons/close_icon.svg",
    alt: ""
  })
], -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-12",
  style: {"text-align":"center"}
}, " Gagal Melakukan Upload Dokumen ", -1)
const _hoisted_211 = [
  _hoisted_209,
  _hoisted_210
]
const _hoisted_212 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_213 = {
  key: 1,
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}
const _hoisted_214 = {
  key: 4,
  type: "button",
  class: "btn btn-danger",
  style: {"width":"150px"},
  "data-bs-dismiss": "modal"
}
const _hoisted_215 = { class: "row mt-5 mb-5" }
const _hoisted_216 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_history"
}
const _hoisted_217 = { class: "modal-dialog modal-xl" }
const _hoisted_218 = { class: "modal-content" }
const _hoisted_219 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_220 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, " History Upload Sekolah ", -1)
const _hoisted_221 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_222 = { class: "svg-icon svg-icon-2x" }
const _hoisted_223 = { class: "modal-body row" }
const _hoisted_224 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"20px","text-align":"center"} }, " Sekolah AAA")
  ])
], -1)
const _hoisted_225 = { class: "row" }
const _hoisted_226 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, "File Upload"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Creator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Detail"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_228 = { key: 0 }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_230 = { class: "text-center" }
const _hoisted_231 = { class: "text-center" }
const _hoisted_232 = { class: "text-center" }
const _hoisted_233 = { class: "text-center" }
const _hoisted_234 = { class: "text-center" }
const _hoisted_235 = { class: "text-center" }
const _hoisted_236 = ["onClick"]
const _hoisted_237 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_238 = [
  _hoisted_237
]
const _hoisted_239 = { key: 1 }
const _hoisted_240 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1)
const _hoisted_241 = [
  _hoisted_240
]
const _hoisted_242 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-success",
    "data-bs-dismiss": "modal"
  }, " Oke ")
], -1)
const _hoisted_243 = { class: "row mt-5 mb-5" }
const _hoisted_244 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_upload_personal"
}
const _hoisted_245 = { class: "modal-dialog" }
const _hoisted_246 = { class: "modal-content" }
const _hoisted_247 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_248 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Upload Foto", -1)
const _hoisted_249 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_250 = { class: "svg-icon svg-icon-2x" }
const _hoisted_251 = { class: "modal-body row" }
const _hoisted_252 = { class: "row" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nama ")
], -1)
const _hoisted_254 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_255 = { class: "col-8" }
const _hoisted_256 = { style: {"font-size":"12px"} }
const _hoisted_257 = { class: "row" }
const _hoisted_258 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 1 ")
], -1)
const _hoisted_259 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_260 = { class: "col-8" }
const _hoisted_261 = { style: {"font-size":"12px"} }
const _hoisted_262 = { class: "row" }
const _hoisted_263 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Nomor Identitas 2 ")
], -1)
const _hoisted_264 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_265 = { class: "col-8" }
const _hoisted_266 = { style: {"font-size":"12px"} }
const _hoisted_267 = { class: "row" }
const _hoisted_268 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"12px"} }, " Detail Kelas ")
], -1)
const _hoisted_269 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, ":", -1)
const _hoisted_270 = { class: "col-8" }
const _hoisted_271 = { style: {"font-size":"12px"} }
const _hoisted_272 = { class: "row mt-3" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Upload Foto Siswa"),
  /*#__PURE__*/_createElementVNode("span", null, "         "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "( Format .jpg .jpeg .png )")
], -1)
const _hoisted_274 = { class: "row mt-2" }
const _hoisted_275 = ["src"]
const _hoisted_276 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_277 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_278 = { class: "row mt-5 mb-5" }
const _hoisted_279 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_edit_personal"
}
const _hoisted_280 = { class: "modal-dialog modal-xl" }
const _hoisted_281 = { class: "modal-content" }
const _hoisted_282 = {
  class: "modal-header",
  style: {"padding-top":"10px","padding-bottom":"5px"}
}
const _hoisted_283 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title justify-content-center" }, "Edit Data", -1)
const _hoisted_284 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_285 = { class: "svg-icon svg-icon-2x" }
const _hoisted_286 = { class: "modal-body row" }
const _hoisted_287 = { class: "col-lg-6" }
const _hoisted_288 = { class: "row" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nama ", -1)
const _hoisted_290 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_291 = { class: "col-12" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nomor Identitas 1 ", -1)
const _hoisted_293 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_294 = { class: "col-12" }
const _hoisted_295 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Nomor Identitas 2 ", -1)
const _hoisted_296 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_297 = { class: "col-12" }
const _hoisted_298 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tempat Lahir ", -1)
const _hoisted_299 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_300 = { class: "col-12" }
const _hoisted_301 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tanggal Lahir ", -1)
const _hoisted_302 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_303 = { class: "col-12" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Jenis Kelamin ", -1)
const _hoisted_305 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_306 = { class: "col-12" }
const _hoisted_307 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " kelas ", -1)
const _hoisted_308 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_309 = { class: "col-12" }
const _hoisted_310 = { class: "col-lg-6" }
const _hoisted_311 = { class: "row" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Detail Kelas ", -1)
const _hoisted_313 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_314 = { class: "col-12" }
const _hoisted_315 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Alamat ", -1)
const _hoisted_316 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_317 = { class: "col-12" }
const _hoisted_318 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Tags ", -1)
const _hoisted_319 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_320 = { class: "col-12" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 col-3 text-center bd-highlight",
  style: {"font-size":"small"}
}, " Note ", -1)
const _hoisted_322 = { class: "p-3 col-9 bd-highlight" }
const _hoisted_323 = { class: "col-12" }
const _hoisted_324 = {
  class: "modal-footer",
  style: {"padding-top":"5px","padding-bottom":"10px"}
}
const _hoisted_325 = /*#__PURE__*/_createElementVNode("div", { class: "container px-7" }, [
  /*#__PURE__*/_createElementVNode("hr", {
    style: {"width":"100%"},
    size: "10",
    color: "black"
  })
], -1)

export function render(_ctx: any,_cache: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_UploadCardStatus = _resolveComponent("UploadCardStatus")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_vue3_tags_input = _resolveComponent("vue3-tags-input")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (_openBlock(), _createElementBlock("input", {
                  name: "filedepan",
                  type: "file",
                  id: "filedepan",
                  class: "form-control form-control-lg",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFileDesainDepan($event))),
                  key: _ctx.fileInputKey1
                }, null, 32))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("img", {
                  alt: "filedepan",
                  class: "pl-3",
                  style: {"max-width":"350px"},
                  src: _ctx.urlimagedepanshow
                }, null, 8, _hoisted_12)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_openBlock(), _createElementBlock("input", {
                  name: "filebelakang",
                  type: "file",
                  id: "filebelakang",
                  class: "form-control form-control-lg",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileDesainBelakang($event))),
                  key: _ctx.fileInputKey1
                }, null, 32))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("img", {
                  alt: "filebelakang",
                  class: "pl-3",
                  style: {"max-width":"350px"},
                  src: _ctx.urlimagebelakangshow
                }, null, 8, _hoisted_19)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: "btn btn-md btn-danger me-3",
          id: "btnBayar",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelDesain()))
        }, " Batal "),
        _createElementVNode("button", {
          class: "btn btn-md btn-primary me-3",
          id: "btnBayar",
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.simpanDesain()))
        }, " Simpan ")
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_ctx.company?.schoolFeature?.cardBarcode)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    hidden: "",
                    class: "btn btn-md me-3",
                    style: {"background-color":"black","color":"white"},
                    id: "btnUpload",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateBarcode()))
                  }, " Generate Barcode "))
                : _createCommentVNode("", true),
              _createVNode(_component_UploadCardStatus, {
                onGetData: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getData(_ctx.paging.size, _ctx.paging.page)))
              }),
              _createElementVNode("button", {
                class: "btn btn-md btn-primary me-3",
                id: "btnUpload",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showUploadMultiple && _ctx.showUploadMultiple(...args)))
              }, " Upload Foto "),
              _createElementVNode("button", {
                class: "btn btn-sm btn-blue me-3",
                style: {"background-color":"darkblue","color":"white"},
                id: "btnBayar",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.verifikasiMultiple && _ctx.verifikasiMultiple(...args)))
              }, " Verifikasi Semua "),
              _createElementVNode("button", {
                class: "btn btn-md btn-warning me-3",
                id: "btnUpload",
                type: "button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.HistoryFunction()))
              }, " History "),
              (_ctx.showDropdownBtnHistory == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.History()))
                    }, "History Upload Excel"),
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.HistoryFoto()))
                    }, "History Upload Foto")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-md btn-success me-3",
                id: "btnHistory",
                type: "button",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.myFunction()))
              }, " Tambah User "),
              (_ctx.showDropdownBtn == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.importExcel()))
                    }, "Tambah by Excel")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-md me-3",
                id: "btnDownload",
                style: {"background-color":"#8950fc","color":"#fff"},
                type: "button",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downloadFunction()))
              }, " Download "),
              (_ctx.showDropdownBtnHDownload == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.unduhDataSemua()))
                    }, "Download Semua Data"),
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.unduhDataSemua(true)))
                    }, "Download Data Berdasar Filter"),
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.unduhFotoSemua()))
                    }, "Download Semua Foto"),
                    _createElementVNode("a", {
                      class: _normalizeClass(["btn", !_ctx.filterPhoto && 'disabled']),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.unduhFotoSemua(true)))
                    }, "Download Foto Berdasar Filter", 2)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control ps-15",
                  placeholder: "Cari Nama",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.nama) = $event)),
                  onKeyup: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changePageSize()))
                }, null, 544), [
                  [_vModelText, _ctx.nama]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _createVNode(_component_vue3_tags_input, {
                  tags: _ctx.nis,
                  placeholder: "Cari Nomor Identitas Lalu tekan Enter",
                  onOnTagsChanged: _ctx.handleChangeNis,
                  style: {"width":"100%"}
                }, null, 8, ["tags", "onOnTagsChanged"])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.tag,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.tag) = $event)),
                  placeholder: "Cari Tag",
                  mode: "multiple",
                  hideSelected: false,
                  searchable: "",
                  options: _ctx.tagList
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isPhoto,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isPhoto) = $event)),
                  placeholder: "Pilih Status Foto",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listDenganFoto,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.pilihFilterFoto($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isSchool,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isSchool) = $event)),
                  placeholder: "Pilih Status Verifikasi",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listValidasi,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.pilihFilterValidasi($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_Multiselect, {
                  class: "mx-1",
                  modelValue: _ctx.isPrint,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isPrint) = $event)),
                  placeholder: "Pilih Status Cetak",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listPrintStatus,
                  searchable: true,
                  label: "name",
                  "track-by": "name",
                  "value-prop": "_id",
                  onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.filterPrintStatus($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _hoisted_48
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        (_ctx.listItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "col-lg-6 fv-row pa-2 ma-2"
                }, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("h3", _hoisted_53, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("img", {
                          alt: "",
                          class: "img-fluid",
                          src: _ctx.getImageSiswa(item.photoContent, item.photoUrl)
                        }, null, 8, _hoisted_56)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("label", _hoisted_62, _toDisplayString(item.nis), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _hoisted_65,
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("label", _hoisted_67, _toDisplayString(item.nisn), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _hoisted_70,
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", _hoisted_72, _toDisplayString(item.placeOfBirth) + ", " + _toDisplayString(_ctx.dateOnly(item.dateOfBirth)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _hoisted_75,
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("label", _hoisted_77, _toDisplayString(item.grade), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _hoisted_79,
                        _hoisted_80,
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("label", _hoisted_82, _toDisplayString(item.gradeDetail), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _hoisted_85,
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("label", _hoisted_87, [
                            (item.gender == 'MALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_88, " Laki - Laki "))
                              : _createCommentVNode("", true),
                            (item.gender == 'FEMALE')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_89, " Perempuan "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _hoisted_91,
                        _hoisted_92,
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("label", _hoisted_94, _toDisplayString(item.address), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _hoisted_97,
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.convertTags(item.tags)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _hoisted_102,
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("label", _hoisted_104, _toDisplayString(item.note), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _hoisted_107,
                        _createElementVNode("div", _hoisted_108, [
                          _createElementVNode("label", {
                            style: _normalizeStyle({
                      color: _ctx.colorStatus(item.isPrint),
                      fontSize: '12px',
                    })
                          }, _toDisplayString(_ctx.getStatusCetak(item.isPrint)), 5)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _hoisted_111,
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("label", {
                            style: _normalizeStyle({
                      color: _ctx.colorStatus(item.isSchoolValid),
                      fontSize: '12px',
                    })
                          }, _toDisplayString(_ctx.getStatusVerifikasiSekolah(item.isSchoolValid)), 5)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        (!item.isSchoolValid)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-blue me-3",
                              style: {"background-color":"darkblue","color":"white"},
                              id: "btnVerifikasi",
                              type: "button",
                              onClick: ($event: any) => (_ctx.verifikasiPersonal(_ctx.index, item))
                            }, " Verifikasi ", 8, _hoisted_115))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary me-3",
                          id: "btnUpload",
                          type: "button",
                          onClick: ($event: any) => (_ctx.uploadPersonal(item)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_upload_personal"
                        }, " Upload Foto ", 8, _hoisted_116),
                        (!item.isSchoolValid)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-sm btn-warning me-3",
                              id: "btnEdit",
                              type: "button",
                              onClick: ($event: any) => (_ctx.editPersonal(item)),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_edit_personal"
                            }, " Edit ", 8, _hoisted_117))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-sm btn-warning me-3",
                              id: "btnEdit",
                              type: "button",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleNoEdit()))
                            }, " Edit ")),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-danger me-3",
                          id: "btnHapus",
                          type: "button",
                          onClick: ($event: any) => (_ctx.hapusPersonal(_ctx.index, item))
                        }, " Hapus ", 8, _hoisted_118)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_119, _hoisted_121)),
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_125))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_126, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("ul", _hoisted_128, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_129, [
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _hoisted_134,
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("span", _hoisted_136, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_137, [
                  (_ctx.showResultUploadMultiple == false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                        _hoisted_139,
                        (_openBlock(), _createElementBlock("input", {
                          name: "filefotomultiple",
                          type: "file",
                          id: "filefotomultiple",
                          class: "form-control form-control-lg mx-5",
                          multiple: "",
                          onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handlefilefotomultiple($event))),
                          key: _ctx.fileInputKeyMultiple
                        }, null, 32))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, _hoisted_142))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                        _hoisted_144,
                        _createElementVNode("div", _hoisted_146, [
                          _createElementVNode("label", _hoisted_147, [
                            _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.resultTotalMultipleUpload), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                        _hoisted_150,
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("label", _hoisted_153, [
                            _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.resultSuccessMultipleUpload), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                        _hoisted_156,
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("label", _hoisted_159, [
                            _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.resultFailedMultipleUpload), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_161
                ]),
                _createElementVNode("div", _hoisted_164, [
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-warning",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.HistoryFotoFromUpload()))
                      }, " History Upload Foto "))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == true)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_165, " OK "))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == false)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_166, " Batal "))
                    : _createCommentVNode("", true),
                  (_ctx.showResultUploadMultiple == false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.simpanFotoMultiple()))
                      }, " Simpan "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 512)
        ]),
        _createElementVNode("div", _hoisted_167, [
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("div", _hoisted_169, [
              _createElementVNode("div", _hoisted_170, [
                _createElementVNode("div", _hoisted_171, [
                  _hoisted_172,
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("span", _hoisted_174, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_175, [
                  _hoisted_176,
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("label", _hoisted_179, [
                        _hoisted_180,
                        _createElementVNode("span", _hoisted_181, _toDisplayString(_ctx.summary.photoUrl), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("label", _hoisted_183, [
                        _hoisted_184,
                        _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.summary.nothingphotoUrl), 1)
                      ])
                    ])
                  ]),
                  _hoisted_186
                ]),
                _createElementVNode("div", _hoisted_187, [
                  _hoisted_188,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.simpanVerifikasiMultiple()))
                  }, " Ok ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_189, [
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                  (_ctx.resultImportExcel == false)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_194, " Upload Data Excel "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == true)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_195, " Berhasil "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == false)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_196, " Gagal "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_197, [
                    _createElementVNode("span", _hoisted_198, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_199, [
                  (_ctx.resultImportExcel == false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                        _hoisted_201,
                        (_openBlock(), _createElementBlock("input", {
                          name: "fileexcel",
                          type: "file",
                          id: "fileexcel",
                          class: "form-control form-control-lg mx-5",
                          onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handlefileexcel($event))),
                          key: _ctx.fileInputKey3
                        }, null, 32))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.targetDataUploadExcel.fileexcel == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                        _createElementVNode("div", _hoisted_203, _toDisplayString(_ctx.errorUploadExcel.file), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, _hoisted_207))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_208, _hoisted_211))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_212, [
                  (_ctx.resultImportExcel == false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.downloadTemplateExcel()))
                      }, " Download Template "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == false)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_213, " Batal "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.importExcelVerifikasi()))
                      }, " Simpan "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == true)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "btn btn-primary",
                        style: {"width":"150px"},
                        "data-bs-dismiss": "modal",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.goToPageHistory()))
                      }, " Oke "))
                    : _createCommentVNode("", true),
                  (_ctx.resultImportExcel == true && _ctx.successImport == false)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_214, " Tutup "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_215, [
          _createElementVNode("div", _hoisted_216, [
            _createElementVNode("div", _hoisted_217, [
              _createElementVNode("div", _hoisted_218, [
                _createElementVNode("div", _hoisted_219, [
                  _hoisted_220,
                  _createElementVNode("div", _hoisted_221, [
                    _createElementVNode("span", _hoisted_222, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_223, [
                  _hoisted_224,
                  _createElementVNode("div", _hoisted_225, [
                    _createElementVNode("table", _hoisted_226, [
                      _hoisted_227,
                      (_ctx.tableDataHistory.length)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_228, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataHistory, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _hoisted_229,
                                _createElementVNode("td", _hoisted_230, _toDisplayString(item.fileName), 1),
                                _createElementVNode("td", _hoisted_231, _toDisplayString(item.creatorName), 1),
                                _createElementVNode("td", _hoisted_232, _toDisplayString(_ctx.dateTime(item.createTime)), 1),
                                _createElementVNode("td", _hoisted_233, _toDisplayString(item.status), 1),
                                _createElementVNode("td", _hoisted_234, _toDisplayString(item.detail), 1),
                                _createElementVNode("td", _hoisted_235, [
                                  _createElementVNode("a", {
                                    class: "symbol symbol-35px me-2",
                                    "data-bs-toggle": "tooltip",
                                    title: "Detail",
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (
                                _ctx.$router.push(
                                  '/sekolah/view-detail-invoices/' + item._id
                                )
                              )
                                  }, _hoisted_238, 8, _hoisted_236)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_239, _hoisted_241))
                    ])
                  ])
                ]),
                _hoisted_242
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_243, [
          _createElementVNode("div", _hoisted_244, [
            _createElementVNode("div", _hoisted_245, [
              _createElementVNode("div", _hoisted_246, [
                _createElementVNode("div", _hoisted_247, [
                  _hoisted_248,
                  _createElementVNode("div", _hoisted_249, [
                    _createElementVNode("span", _hoisted_250, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_251, [
                  _createElementVNode("div", _hoisted_252, [
                    _hoisted_253,
                    _hoisted_254,
                    _createElementVNode("div", _hoisted_255, [
                      _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.targetData.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_257, [
                    _hoisted_258,
                    _hoisted_259,
                    _createElementVNode("div", _hoisted_260, [
                      _createElementVNode("label", _hoisted_261, _toDisplayString(_ctx.targetData.nis), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_262, [
                    _hoisted_263,
                    _hoisted_264,
                    _createElementVNode("div", _hoisted_265, [
                      _createElementVNode("label", _hoisted_266, _toDisplayString(_ctx.targetData.nisn), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_267, [
                    _hoisted_268,
                    _hoisted_269,
                    _createElementVNode("div", _hoisted_270, [
                      _createElementVNode("label", _hoisted_271, _toDisplayString(_ctx.targetData.gradeDetail), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_272, [
                    _hoisted_273,
                    (_openBlock(), _createElementBlock("input", {
                      name: "fotosiswapersonal",
                      type: "file",
                      id: "fotosiswapersonal",
                      class: "form-control form-control-lg",
                      onChange: _cache[40] || (_cache[40] = ($event: any) => (_ctx.handleFotoSiswaPersonal($event))),
                      key: _ctx.fileInputKey3
                    }, null, 32))
                  ]),
                  _createElementVNode("div", _hoisted_274, [
                    _createElementVNode("img", {
                      alt: "filepersonal",
                      class: "pl-3",
                      style: {"max-width":"300px"},
                      src: _ctx.imageFotoPersonal
                    }, null, 8, _hoisted_275)
                  ])
                ]),
                _createElementVNode("div", _hoisted_276, [
                  _hoisted_277,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.simpanUploadPersonal()))
                  }, " Simpan ")
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_278, [
          _createElementVNode("div", _hoisted_279, [
            _createElementVNode("div", _hoisted_280, [
              _createElementVNode("div", _hoisted_281, [
                _createElementVNode("div", _hoisted_282, [
                  _hoisted_283,
                  _createElementVNode("div", _hoisted_284, [
                    _createElementVNode("span", _hoisted_285, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_286, [
                  _createElementVNode("div", _hoisted_287, [
                    _createElementVNode("div", _hoisted_288, [
                      _hoisted_289,
                      _createElementVNode("div", _hoisted_290, [
                        _createElementVNode("div", _hoisted_291, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "nama",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.name,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.targetData.name) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_292,
                      _createElementVNode("div", _hoisted_293, [
                        _createElementVNode("div", _hoisted_294, [
                          _createVNode(_component_Field, {
                            disabled: "",
                            type: "text",
                            name: "nis",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.nis,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.targetData.nis) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_295,
                      _createElementVNode("div", _hoisted_296, [
                        _createElementVNode("div", _hoisted_297, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "nisn",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.nisn,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.targetData.nisn) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_298,
                      _createElementVNode("div", _hoisted_299, [
                        _createElementVNode("div", _hoisted_300, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "ttl",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.placeOfBirth,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.targetData.placeOfBirth) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_301,
                      _createElementVNode("div", _hoisted_302, [
                        _createElementVNode("div", _hoisted_303, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "ttl",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.dateOfBirth,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.targetData.dateOfBirth) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_304,
                      _createElementVNode("div", _hoisted_305, [
                        _createElementVNode("div", _hoisted_306, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "gender",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.gender,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.targetData.gender) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_307,
                      _createElementVNode("div", _hoisted_308, [
                        _createElementVNode("div", _hoisted_309, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "kelas",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.grade,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.targetData.grade) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_310, [
                    _createElementVNode("div", _hoisted_311, [
                      _hoisted_312,
                      _createElementVNode("div", _hoisted_313, [
                        _createElementVNode("div", _hoisted_314, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "detail_kelas",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.targetData.gradeDetail,
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.targetData.gradeDetail) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_315,
                      _createElementVNode("div", _hoisted_316, [
                        _createElementVNode("div", _hoisted_317, [
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            name: "alamat",
                            class: "form-control form-control-lg",
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.targetData.address) = $event))
                          }, "\n                        ", 512), [
                            [_vModelText, _ctx.targetData.address]
                          ])
                        ])
                      ]),
                      _hoisted_318,
                      _createElementVNode("div", _hoisted_319, [
                        _createElementVNode("div", _hoisted_320, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.targetData.tags,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.targetData.tags) = $event)),
                            class: "form-control",
                            multiple: "",
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            placeholder: "Isi Tags",
                            "allow-duplicates": "false"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _hoisted_321,
                      _createElementVNode("div", _hoisted_322, [
                        _createElementVNode("div", _hoisted_323, [
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            name: "note",
                            class: "form-control form-control-lg",
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.targetData.note) = $event))
                          }, "\n                        ", 512), [
                            [_vModelText, _ctx.targetData.note]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_324, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.batalEditPersonal()))
                  }, " Batal "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.simpanEditPersonal()))
                  }, " Simpan ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_325
    ], 2)
  ], 64))
}